import React from 'react';
import {Box} from '@mui/material';
import {AspectRatio} from '@contentlab/types/aspectRatio';
import AssetPreviewMedia from '@/views/content-studio/components/asset-preview-modal/asset-preview-modal-content/asset-preview-media';
import AssetPreviewPanel from '@/views/content-studio/components/asset-preview-modal/asset-preview-panel/AssetPreviewPanel';
import {PreviewAsset} from '@/views/content-studio/components/asset-preview-modal/types';
import styles from './AssetPreviewModalContent.module.scss';

export interface AssetPreviewModalContentProps {
  testID?: string;
  asset: PreviewAsset;
  presentationId: string;
}

function convertAspectRatioToNumber(aspectRatio?: AspectRatio): number | null {
  if (!aspectRatio) return null;

  const [width, height] = aspectRatio.split(':').map(Number);
  return width / height;
}

function AssetPreviewModalContent(props: AssetPreviewModalContentProps) {
  const {testID = 'asset-preview-modal-content', asset, presentationId} = props;
  return (
    <Box className={styles.modalContentContainer} data-testid={testID}>
      {asset.url && (
        <Box className={styles.mediaContainer}>
          <AssetPreviewMedia
            videoUrl={asset.url || null}
            aspectRatio={convertAspectRatioToNumber(asset.metadata.aspectRatio)}
          />
        </Box>
      )}
      <Box className={styles.panelContainer}>
        <AssetPreviewPanel asset={asset} presentationId={presentationId} />
      </Box>
    </Box>
  );
}

export default AssetPreviewModalContent;
